<template>
    <el-table
        v-loading="isLoading"
        :data="computedData"
        class="row-click ah-el-data-table salary-page-summary-table"
        show-summary
        :summary-method="getSummaries"
        @row-click="$event => $emit('row-click', $event)"
    >
        <el-table-column prop="month" label="所屬月份" sortable class-name="col-date">
            <template slot-scope="scope">
                <span class="strong">{{ scope.row.year }} 年 {{ scope.row.month }} 月</span>
            </template>
        </el-table-column>
        <el-table-column prop="fixedSalaryAmount" label="固定薪資" align="right" class-name="col-fixed-salary" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.fixedSalaryAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="nonFixedSalaryAmount" label="非固定薪資" class-name="col-nonfixed-salary" align="right" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.nonFixedSalaryAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="salaryAmount" align="right" class-name="col-salary-amount" sortable>
            <template slot="header"> 薪資總額<ah-tip>固定薪資＋非固定薪資</ah-tip> </template>
            <template slot-scope="scope">
                <Money :v="scope.row.salaryAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="bonusAmount" label="績效、獎金" align="right" class-name="col-bonus" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.bonusAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="incomeAmount" align="right" class-name="col-income-amount" sortable>
            <template slot="header"> 所得總額<ah-tip>固定薪資＋非固定薪資＋績效、獎金</ah-tip> </template>
            <template slot-scope="scope">
                <Money :v="scope.row.incomeAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="staffCostAmount" label="人事費用" class-name="col-staff-cost-amt" align="right" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.staffCostAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="staffCostRate" width="90" align="right" class-name="col-staff-cost-rat" sortable type="percentage">
            <template slot="header"> ％<ah-tip>人事費用 / 固定薪資總額</ah-tip> </template>
            <template slot-scope="scope">
                <span style="font-weight: bold"> {{ Math.round(scope.row.staffCostRate * 1000) / 10 }}% </span>
            </template>
        </el-table-column>
        <el-table-column prop="staffSalaryAmount" align="right" class-name="col-staff-salary-amt" sortable>
            <template slot="header">
                人事薪資總額
                <ah-tip> 固定薪資＋非固定薪資＋績效、獎金＋人事費用 </ah-tip>
            </template>
            <template slot-scope="scope">
                <Money :v="scope.row.staffSalaryAmount" />
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    computed: {
        computedData() {
            return this.data.map((o) => ({
                ...o,
                incomeAmount: o.salaryAmount,
                salaryAmount: o.salaryAmount - o.bonusAmount,
            }));
        },
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '總計';
                    return;
                }
                if (column.type === 'percentage') return;

                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => Number.isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!Number.isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = 'N/A';
                }
            });

            // 人事薪資比例計算：人事費用 / 固定薪資
            sums[7] = `${Math.round((sums[6] / sums[1]) * 100)}%`;

            sums.forEach((sum, index) => {
                // 0 是總計, 7 是人事薪資比例，另外處理
                if (index !== 0 && index !== 7) {
                    if (!Number.isNaN(sums[index])) {
                        sums[index] = Number.parseInt(sums[index], 10).toLocaleString('en-US');
                    }
                }
            });

            return sums;
        },
    },
};
</script>

<style lang="scss">
.salary-page-summary-table {
    .col-date,
    .col-bonus,
    .col-salary-amount,
    .col-income-amount,
    .col-staff-cost-rat {
        border-right: 1px solid #ebeef5;
    }
    .col-fixed-salary,
    .col-nonfixed-salary,
    .col-bonus,
    .col-staff-cost-amt {
        // background-color: #f9f9fc;
    }

    .el-table__header-wrapper tbody td,
    .el-table__footer-wrapper tbody td {
        // background-color: #fff;
        // border-top: 1px solid #ccc;
        font-weight: bold;
    }
}
</style>
